import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-register-module',
  templateUrl: './register-module.component.html',
  styleUrls: ['./register-module.component.scss']
})
export class RegisterModuleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
